import React from 'react'
import { connect } from 'react-redux';
import { stockActions } from '../../actions/trading/stock.action';
import { ACTION_TYPE } from "../../constants/w-socket";
import '../../assets/styles/components/instrument/bid-ask.scss';
import { formatFunctions, Converter } from '../../helpers/functions';
import { dataType } from '../../constants/data-type';
class BidAsk extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bidData: Array(5).fill({ price: '-', qty: '-' }),
      askData: Array(5).fill({ price: '-', qty: '-' }),
      bidAllQtyRate: '',
      askAllQtyRate: '',
    }
  }
  render() {
    const { language, handleQueueItemClick } = this.props;
    const { bidData, askData, bidAllQtyRate, askAllQtyRate } = this.state;
    return (
      <div className="bid-ask-container">
        <header>
          <span>{language.common_best_bid}</span>
          <span>{language.common_best_ask}</span>
        </header>
        <div className="percent">
          <span style={{ minWidth: `${bidAllQtyRate ? bidAllQtyRate : 50}%` }}>{bidAllQtyRate ? bidAllQtyRate : 50}%</span>
          <span style={{ minWidth: `${askAllQtyRate ? askAllQtyRate : 50}%` }}>{askAllQtyRate ? askAllQtyRate : 50}%</span>
        </div>
        <section>
          <div className="item-list bid-list">
            {bidData.map((bid, index) =>
              <div key={`${bid.price}${index}`} className="item" onClick={() => handleQueueItemClick(bid, true)}>
                <span className="item_label">{language[`common_bid_price_${++index}`]}</span>
                <div className="item-content">
                  <span>{formatFunctions.dataFormat(bid.price, dataType.CURRENCY)}</span>
                  <span>{this.formatNumber(formatFunctions.dataFormat(bid.qty, dataType.NUMBER))}</span>
                </div>
              </div>
            )}
          </div>
          <div className="item-list ask-list">
            {askData.map((ask, index) =>
              <div key={`${ask.price}${index}`} className="item" onClick={() => handleQueueItemClick(ask, false)}>
                <span className="item_label">{language[`common_ask_price_${++index}`]}</span>
                <div className="item-content">
                  <span>{formatFunctions.dataFormat(ask.price, dataType.CURRENCY)}</span>
                  <span>
                    {this.formatNumber(formatFunctions.dataFormat(ask.qty, dataType.NUMBER))}
                  </span>
                </div>
              </div>
            )}
          </div>
        </section>
      </div>
    )
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return
    }
  }

  formatNumber = (num) => {
    if (!num) return
    let numArr = String(num).split(',')
    if (numArr.length === 2) {
      return `${numArr[0]}${numArr[1] === '000' ? '' : '.' + numArr[1]}K`
    } else {
      return num
    }
  }

  getDetailData = async() => {
    const { marketParams, language, mdsToken,currentTradingAccount } = this.props;
    const { clientID, tradingAccSeq } = currentTradingAccount
    if (!(marketParams.stockCode && mdsToken)) {
      this.setState({
        bidData: Array(5).fill({ price: '-', qty: '-' }),
        askData: Array(5).fill({ price: '-', qty: '-' }),
        bidAllQtyRate: '',
        askAllQtyRate: '',
      })
      return
    }
    // if(!mdsToken){
    //   if(clientID){
    //    await new Promise(resolve => this.props.loginMDS(clientID , resolve))
    //   }
    // }
    let params = {
      symbols: [
        {
          exchangeID: Converter.mappingWebSocketMarket(marketParams.marketID),
          key: Converter.mappingStockCode(marketParams.stockCode)
        }
      ],
      sessID: mdsToken
    }
    this.props.getDetailPriceInfoData(params, res => {
      if (res['bids']) {
        if (res.bids.length > 0 || res.asks.length > 0) {
          let bid = res.bids.slice(0, 5);
          let ask = res.asks.slice(0, 5);
          let bidAllQty = this.state.bidData;
          let askAllQty = this.state.askData;
          if (res.bids.length > 0) {
            bidAllQty = res.bids.reduce((total, num) => {
              if (total instanceof Object) {
                return total.qty + num.qty
              } else {
                return total + num.qty
              }
            });
          }

          if (res.asks.length > 0) {
            askAllQty = res.asks.reduce((total, num) => {
              if (total instanceof Object) {
                return total.qty + num.qty
              } else {
                return total + num.qty
              }
            });
          }

          let bidAllQtyRate = parseFloat((bidAllQty / (bidAllQty + askAllQty)) * 100).toFixed(2)
          let askAllQtyRate = parseFloat((askAllQty / (bidAllQty + askAllQty)) * 100).toFixed(2)
          this.setState({
            bidData: bid,
            askData: ask,
            bidAllQtyRate,
            askAllQtyRate,
          })
        }

      }
    }

    )
  }

  componentDidMount() {
    this.getDetailData()
  }

  componentDidUpdate(preProps) {
    const { marketParams, mdsToken } = this.props;
    if (marketParams && JSON.stringify(preProps.marketParams) !== JSON.stringify(marketParams) || preProps.mdsToken !== mdsToken) {
      this.getDetailData()
    }

    // if (mdsToken && preProps.mdsToken !== mdsToken) {
    //   this.getDetailData()
    // }
  }
}

BidAsk.defaultProps = {
  handleQueueItemClick: () => {}
}

export default connect(
  state => ({
    language: state.app.language,
    marketParams: state.trade.marketParams,
    mdsToken: state.trade.mdsToken,
    currentTradingAccount: state.trade.currentTradingAccount,
  }),
  dispatch => ({
    getDetailPriceInfoData: (p, c) => dispatch(stockActions.getDetailPriceInfoAction(p, c)),
    // loginMDS: (p, c) => dispatch(stockActions.loginMDSAction(p, c))
  })
)(BidAsk)
